import apiClient from "@/services/apiClient";

// Public "Apply to teach" form, submitted from the homepage's tutor-recruitment section
// (TutorRecruitment.js) via TutorApplicationModal.js. No auth required -- proxied through
// pages/api/public/[...path].js to the Laravel backend's /v1/user/tutor-applications route.
export async function submitTutorApplication(payload) {
  const { data } = await apiClient.post("/public/tutor-applications", payload);
  return data;
}
